import React, { FC, ReactNode } from 'react';
import { Tooltip } from 'react-tooltip';

type TooltipWrapperProps = {
  content: string | ReactNode;
  id: string;
  delayShow?: number;
  children: ReactNode;
  place?: 'bottom' | 'top' | 'right' | 'left';
  truncate?: boolean;
  className?: string;
  contentClassName?: string;
};

const TooltipWrapper: FC<TooltipWrapperProps> = ({
  content,
  id,
  children,
  delayShow = 500,
  place = 'bottom',
  truncate = false,
  className,
  contentClassName,
}) => {
  return (
    <>
      <div className={`${truncate ? 'truncate' : ''} ${className ?? ''}`} data-tooltip-id={id}>
        {children}
      </div>

      <Tooltip
        id={id}
        place={place}
        delayShow={delayShow}
        className={`!z-[9999] !text-[12px] ${contentClassName ?? ''} 
    [&_.react-tooltip-content-wrapper]:!text-white
    [&_.react-tooltip-content-wrapper]:opacity-100
  `}
      >
        {content}
      </Tooltip>
    </>
  );
};

export default TooltipWrapper;
